// extracted by mini-css-extract-plugin
export default {"header":"styles_header__fD6+A","box":"styles_box__HwlS6","content":"styles_content__jT4P-","title":"styles_title__9mci9"};